module.exports = __webpack_public_path__ + "img/badge_expedia.3c963fe6.jpg";